import React from 'react'
import Index from '../_components/Agency/Index'
import Header from '../_components/common/Header'
import useRole from '../hooks/getRole'

const Agency = () => {
  const role = useRole()
  return (
    <>
    {/* <Header userType={role} headerTitle="Agencies"/>   */}
    <Index />
    </>
    
  )
}

export default Agency
